import { buildComponent } from '#components'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

const CollectionsQuickNav = buildComponent({
  name: 'collections-quick-nav',
  onConnected: (component) => {
    initSwiper(component.querySelector<HTMLElement>('.swiper'))
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'collections-quick-nav': typeof CollectionsQuickNav
  }
}

function initSwiper(swiperEl?: HTMLElement | null) {
  if (!swiperEl) return

  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 3.5,
    spaceBetween: 26,
    breakpoints: {
      750: {
        slidesPerView: 6
      },
      990: {
        slidesPerView: 8
      }
    },
    navigation: {
      nextEl: swiperEl.querySelector<HTMLElement>('.custom-swiper-button-next'),
      prevEl: swiperEl.querySelector<HTMLElement>('.custom-swiper-button-prev')
    }
  })
}
